import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const homeFor = (role) => {
  if (role === "cliente") return "/area-riservata";
  if (role === "broker") return "/area-broker";
  if (role === "company") return "/area-compagnia";
  if (role === "super_admin") return "/superadmin";
  return "/dashboard";
};

export const ProtectedRoute = ({ children, roles }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500" data-testid="auth-loading">
        Caricamento…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (roles && !roles.includes(user.role))
    return <Navigate to={homeFor(user.role)} replace />;

  return children;
};

export { homeFor };
